/* eslint-disable no-undef */
// eslint-disable-next-line import/no-unresolved
const storeLocator = require('../storeLocator/storeLocator');
const utils = require('../utils');

const showMapInstorePickup = () => {
    const noApiAlertIsPresent = $(document.querySelector('.map-canvas')).find('.alert-danger')
        .length;
    if (noApiAlertIsPresent) {
        storeLocator.init();
        storeLocator.search();
    }
};

const mapInicializationOnModal = () => {
    $('.pickup-in-store').on('DOMSubtreeModified', () => {
        if ($(document.querySelector('.map-canvas')).find('.alert-danger').length) {
            showMapInstorePickup();
        }
    });
};

module.exports = {
    mapInicializationOnModal,
    managePickupModalInCheckout: () => {
        const docReady = $(document);

        $('.container').on(
            'click',
            'input.form-check-input[data-pickup="true"],.form-check.col-9.start-lines > input.form-check-input[data-pickup="true"] + label',
            () => {
                const storePickupMode = utils.getCookie('storePickupMode');
                if (storePickupMode === 'modal') {
                    $('#pickup-modal').modal('show');
                }
                docReady.find('.btn-storelocator-search').on('ready', () => {
                    storeLocator.search();
                });
            },
        );

        $('.pickup-in-store').on('DOMSubtreeModified', () => {
            if ($(document.querySelector('.map-canvas')).find('.alert-danger').length) {
                showMapInstorePickup();
            }
            docReady.find('.btn-storelocator-search').on('ready', () => {
                storeLocator.search();
            });
        });
    },
};
